import branchFA from './fa/fa.json'

const BranchMessages = {
  fa: { ...branchFA },
}

export default BranchMessages
